'use client'
import { Icon } from '@/components'
import { URL_DECOR } from '@/constants/ui'
import { Button, Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

export const BtnQrCode = ({ link = URL_DECOR + 'fake_qr_code.png' }: { link?: string }) => {
  const t = useTranslations()
  const handleDownload = async () => {
    try {
      const response = await fetch(link)
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'qr-code-payment.png'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Download failed:', error)
    }
  }
  return (
    <Button
      onClick={handleDownload}
      variant="contained"
      sx={{
        color: 'primary.contrastText',
        textTransform: 'none',
        padding: { xs: '8px 12px', md: '12px 20px' },
        fontSize: { xs: '0.75rem', md: '0.875rem' },
        borderRadius: '8px',
        width: '100%',
      }}
    >
      <Stack
        direction={'row'}
        spacing={{ sm: 1, xs: 0.5 }}
        alignItems={'center'}
        sx={{ '&:hover': { color: 'inherit' }, cursor: 'pointer' }}
        component={'span'}
      >
        <Icon.Download
          sx={{
            fontSize: { xs: '0.75rem!important', md: '1rem!important' },
            color: 'inherit',
          }}
        />
        <Typography sx={{ color: 'inherit', fontSize: 'inherit', fontWeight: 600 }}>
          {t('Tải xuống mã QR')}
        </Typography>
      </Stack>
    </Button>
  )
}
